$(document).ready(function () {
    iamagod();
    menu();
    form();
    tab();
    hint();
    popup();
});

function iamagod() {
    if (window.location.search.indexOf('sys=1') !== -1) {
        $('.hys').removeClass('hys');
        $('.hys-padding').removeClass('hys-padding');
    }
}

function menu() {
    $('body').on('click', 'a', function () {
        let href = $(this).attr('href');

        if (href.indexOf('#') != -1) {
            let id = href.substr(href.indexOf('#'));
            if ($(id).length) {
                $('html, body').animate({'scrollTop': $(id).offset().top - $('.header').height()}, 'slow');
                if ($('nav ul').hasClass('sys')) {
                    $('nav ul').removeClass('sys');
                }
                return false;
            }
        }
    });


    if (window.location.href.indexOf('#') != -1) {
        let id = window.location.href.substr(window.location.href.indexOf('#'));
        if ($(id).length) {
            $('html, body').animate({'scrollTop': $(id).offset().top - $('.header').height()}, 'slow');
        }
    }

    $('.header__menu').click(function () {
        $('nav ul').addClass('sys');
    });

    $('.header__button').click(function () {
        $('nav ul').removeClass('sys');
    });

    $(document).click(function (e) {
        if (!$(e.target).closest('nav ul, .header__menu').length) {
            $('nav ul').removeClass('sys');
        }
    });
}

function form() {
    $('.form__check-input[type="radio"]').on('change', function () {
        let self = $(this);
        let target = self.data('target');
        let formSelect = $('.form__select');

        $('.form__custom').hide();
        $('.form__custom .form__control').val('');
        $('.form__group-select').removeClass('has-error');

        formSelect.hide().removeAttr('required');
        formSelect.each(function () {
            $(this).find('option:selected').removeAttr('selected');
            $(this).find('option[hidden]').attr('selected', 'selected');
            $(this).val($(this).find('option[hidden]').val());
        });
        $('.' + target).attr('required', 'required').show();

        if (target === 'form__control-offline') {
            $('.form__control-offline .form__group .form__control').attr('required', 'required');
            $('.form__control-online .form__group .form__control').removeAttr('required');
            $('.form__control-online').not('.form__select').hide();
        } else {

        }

        if (target === 'form__control-online') {
            $('.form__control-online .form__group .form__control').attr('required', 'required');
            $('.form__control-offline .form__group .form__control').removeAttr('required');
            $('.form__control-offline').not('.form__select').hide();
        }
    });

    $('.form__select').on('change', function () {
        let self = $(this);
        let isCustom = self.find('option:selected').data('custom');

        if (isCustom === true) {
            $('.form__custom').show();
            $('.form__custom .form__control').attr('required', 'required').focus();
        } else {
            $('.form__custom').hide();
            $('.form__custom .form__control').removeAttr('required').val('');
        }
    });

    $('.page__section-3-form').on('submit', function (e) {
        e.preventDefault();
        let isValid = true;

        let checkedRadios = [];

        $(this).find('[required]').each(function () {
            let $field = $(this);
            let $group = $field.closest('.form__group');

            if ($field.is(':radio')) {
                let name = $field.attr('name');
                if (checkedRadios.indexOf(name) === -1) {
                    if (!$('input[name="' + name + '"]:checked').length) {
                        $('input[name="' + name + '"]').closest('.form__group').addClass('has-error');
                        isValid = false;
                    }
                    checkedRadios.push(name);
                }
            } else if ($field.is(':checkbox')) {
                if (!$field.is(':checked')) {
                    $group.addClass('has-error');
                    isValid = false;
                }
            } else {
                if (!$field.val()) {
                    $group.addClass('has-error');
                    $group.find('.form__error').text('A mező kitöltése kötelező');
                    isValid = false;
                } else if ($field.attr('type') === 'email') {
                    let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (!emailRegex.test($field.val())) {
                        $group.addClass('has-error');
                        $group.find('.form__error').text('Kérjük, adj meg egy érvényes e-mail címet');
                        isValid = false;
                    }
                }
            }
        });

        if (!isValid) {
            let $firstError = $('.has-error').first();
            $('html, body').animate({
                scrollTop: $firstError.offset().top - $('.header').height() - 20
            }, 'slow');
        }
    });

    $('form').on('change', '[required]', function () {
        let $field = $(this);
        if ($field.is(':radio')) {
            $('input[name="' + $field.attr('name') + '"]').closest('.form__group').removeClass('has-error');
        } else {
            $field.closest('.form__group').removeClass('has-error');
        }
    });

    $('.form__control').on('keydown', function (e) {
        if ($(this).data('space') === false && e.key === ' ') {
            e.preventDefault();
        }
    });

    Inputmask({
        mask: ['+36 9 999 9999[9]', '+36 99 999 9999[9]'],
        placeholder: '',
        showMaskOnHover: false,
        showMaskOnFocus: false,
        keepStatic: false
    }).mask('.form__control-phone');

}

function tab() {
    function limitRows(tabId) {
        let $tab = $('#' + tabId);
        let $rows = $tab.find('.row-item').not('.row-header');
        let $showAllBtn = $('.show-all-' + tabId);

        $rows.removeClass('border-bottom-none');
        $rows.hide();
        $rows.slice(0, 5).show();

        if ($rows.length > 5) {
            $rows.eq(4).addClass('border-bottom-none');
            $showAllBtn.show();
        } else {
            $showAllBtn.hide();
        }
    }

    // Oldalbetöltéskor
    let activeTarget = $('.page__section-5-button.active').data('target');
    if (activeTarget) {
        $('.page__section-5-tab').hide();
        $('#' + activeTarget).show();
        limitRows(activeTarget);
    }

    $('.page__section-5-button').click(function () {
        let $button = $(this);
        let target = $button.data('target');

        $('.page__section-5-button').removeClass('active');
        $button.addClass('active');

        $('.page__section-5-tab').hide();
        $('#' + target).show();

        $('.form__search').val('');
        limitRows(target);
    });

    $('[class^="show-all-"]').click(function () {
        let $activeTab = $('.page__section-5-tab:visible');
        $activeTab.find('.row-item').not('.row-header').removeClass('border-bottom-none').show();
        $(this).hide();
    });

    $('.form__search').on('input', function () {
        let search = $(this).val().toLowerCase();
        let $activeTab = $('.page__section-5-tab:visible');

        $activeTab.find('.row-item').not('.row-header').each(function () {
            let text = $(this).text().toLowerCase();
            if (text.indexOf(search) !== -1) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
    });
}

function hint() {
    $('.form__info').on('click', function () {
        $(this).addClass('sys');
    });

    $(document).on('click', function (e) {
        if (!$(e.target).closest('.form__info, .form__hint').length) {
            $('.form__info').removeClass('sys');
        }
    });
}

function popup() {
    let backdropHTML = '<div class="backdrop sys"></div>';
    $('body').on('click', '.show-popup', function (e) {
        e.preventDefault();

        let target = $(this).data('target');

        $('.popup').removeClass('active');
        $('.popup-' + target).addClass('active');

        $('body').append(backdropHTML);
    });

    $('body').on('click', '.backdrop, .popup__close, .popup__dismiss', function () {
        handlePopup();
    }).on('keyup', function (e) {
        if (e.which == 27) {
            handlePopup();
        }
    });
}

function handlePopup() {
    $('.popup').removeClass('active');
    $('.backdrop').remove();
}